/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_RegardInputs */

const de__field_regard = /** @type {(inputs: _Field_RegardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betreff`)
};

/**

* @param {_Field_RegardInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_regard = /** @type {((inputs?: _Field_RegardInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_RegardInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_regard(inputs)
});